module.exports = __webpack_public_path__ + "img/banner_icon04.d96a00b6.png";